import { TreeNodeBuilder } from "../../../../../../libs/ts/WorkflowTree/Builder/TreeNodeBuilder";
import { ITreeNodeBuilder } from "../../../../../../libs/ts/WorkflowTree/Builder/ITreeNodeBuilder";
import { ITreeNode } from "../../../../../../libs/ts/WorkflowTree/Nodes/ITreeNode";
import { JobCommentsNode } from "../../nodes/JobCommentsNode";
import { SiteAddressDetailsNode } from "../../nodes/SiteAddressDetailsNode";
import { SiteContactDetailsNode } from "../../nodes/SiteContactDetailsNode";
import { JbpTreeNodeData } from "../../treeExtensions/JbpTreeNodeData";
import { IJbpChildNodeRelationship } from "../../treeExtensions/IJbpChildNodeRelationship";
import { IWorkflowFactory } from "./../IWorkflowFactory";
import { DNOBNOQuestions } from "../../nodes/DNOBNOSpecificQuestionsNode";
import { CaptureExtraSkills } from "../../nodes/CaptureExtraSkills";
import { useCanAccess } from "../../hooks/useUserPermissions";

export class BNOBookJobSiteInfoWorkflowFactory extends IWorkflowFactory {

    private siteContactDetailsNode = new SiteContactDetailsNode();
    private siteAddressDetailsNode = new SiteAddressDetailsNode();
    private jobCommentsNode = new JobCommentsNode(this.mpan, this.serviceLine);
    private dnoBnoSpecificQuestionsNode = new DNOBNOQuestions();
    private captureExtraSkills = new CaptureExtraSkills();

    constructor(mpan: string, serviceLine: string) {
        super(mpan, serviceLine);
    }

    public async Build(onTreeChange: () => void): Promise<ITreeNode<JbpTreeNodeData, IJbpChildNodeRelationship>> {
        const shouldShowCaptureExtraSkills = (): boolean => {
            return useCanAccess('canSelectExtraSkills')
        }
        const builder = new TreeNodeBuilder<JbpTreeNodeData, IJbpChildNodeRelationship>(onTreeChange);
        const siteContactDetailsNodeBuilder = builder.AddTreeNode(this.siteContactDetailsNode, IWorkflowFactory.sequenceRelationship);
        const siteAddressDetailsNodeBuilder = siteContactDetailsNodeBuilder.AddTreeNode(this.siteAddressDetailsNode, IWorkflowFactory.sequenceRelationship);
        const dnoBnoSpecificQuestionsNodeBuilder = siteAddressDetailsNodeBuilder.AddTreeNode(this.dnoBnoSpecificQuestionsNode, IWorkflowFactory.sequenceRelationship);

        let extraSkillsBuilder: ITreeNodeBuilder<JbpTreeNodeData, IJbpChildNodeRelationship>;
        if(shouldShowCaptureExtraSkills()) {
            extraSkillsBuilder = dnoBnoSpecificQuestionsNodeBuilder.AddTreeNode(this.captureExtraSkills, IWorkflowFactory.sequenceRelationship);
            extraSkillsBuilder.AddTreeNode(this.jobCommentsNode, IWorkflowFactory.sequenceRelationship);
        } else {
            dnoBnoSpecificQuestionsNodeBuilder.AddTreeNode(this.jobCommentsNode, IWorkflowFactory.sequenceRelationship);
        }

        const tree = builder.Build();
        await this.finaliseTree(tree);
        return tree;
    }
}
